import { END_POINT } from "@constants/api.constants";
import { store } from "@src/store";
import { resetUserTokenAction, setUserTokenAction } from "@reducers/app.reducer";
import { hubHosted, isHubToken, refreshHubToken, redirectToHubSignin } from "@src/utils/hub-sso";

const { SETTINGS, SETTING_DELETE } = END_POINT;

export const getSettingsDataApi = async ({
  orderBy,
  sortBy,
  skip,
  limit,
  filters,
}) => {
  return await fetch(
    `${SETTINGS}?sort_by=${sortBy}&order_by=${orderBy}&skip=${skip}&limit=${limit}${filters}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
        token: store.getState().app?.token,
      },
    }
  )
    .then((res) => res.json())
    .then((response) => {
      // console.log(response.data);
      if (response.status)
        return {
          status: true,
          data: response.data.list,
          totalCount: response.data.total_count,
        };
      else {
        checkForExpiredToken(response.message);
        return { status: false, message: response.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const deleteSettingsDataApi = async (ids) => {
  return await fetch(SETTING_DELETE, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify({ ids }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status)
        return {
          status: true,
          data: data.data.list,
          totalCount: data.data.total_count,
        };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

/** A Hub JWT is short-lived BY DESIGN — it is minted from the Hub session
 *  cookie and expires long before that session does. Treating its expiry the
 *  way a local password login's expiry is treated threw the token away and
 *  put the local username/password form in front of somebody who signed in
 *  through the Hub and has no local password to type. The header already
 *  refreshes correctly on a timer; every other caller went through here and
 *  did the opposite, so whichever fired first decided what happened.
 *
 *  Now: re-exchange the still-valid Hub session for a new JWT and carry on.
 *  Only when the HUB session itself is gone do we clear and send them back
 *  through the Hub's door — never to the local form. A local (opaque) token
 *  keeps the original behaviour exactly. */
let hubRecovery = null;

const recoverHubSession = () => {
  if (hubRecovery) return hubRecovery;
  hubRecovery = (async () => {
    try {
      const token = await refreshHubToken();
      if (token) {
        const user = store.getState().app.user;
        store.dispatch(setUserTokenAction({ token, user }));
        return true;
      }
      store.dispatch(resetUserTokenAction(null));
      redirectToHubSignin();
      return false;
    } finally {
      setTimeout(() => { hubRecovery = null; }, 0);
    }
  })();
  return hubRecovery;
};

export const checkForExpiredToken = (message) => {
  if (message === "Token expired" || message === "Invalid token") {
    const current = store.getState().app.token;
    if (hubHosted() && isHubToken(current)) {
      void recoverHubSession();
      return;
    }
    store.dispatch(resetUserTokenAction());
    return;
  }

  if (message === "Token refresh") window.location = "/refresh-password";
};
